/**
 * Offscreen indicator configuration
 */

export const OFFSCREEN_CONFIG = Object.freeze({
  DIRECTIONS: {
    TOP: 'top',
    BOTTOM: 'bottom', 
    LEFT: 'left',
    RIGHT: 'right',
  },

  STYLING: {
    ARROW_ICON: '/images/icons/white-arrow.svg',
    BADGE_COLOR: '#0F0C88',
  },

  VISIBILITY: {
    HIDDEN_STATES: [0, 1], // Don't show for counts of 1 or less
  },
});


export const INDICATOR_DIRECTIONS = ['top', 'bottom', 'left', 'right'];